/*
 * Public API Surface of third-cms
 */

export * from './lib/third-cms.service';
export * from './lib/third-cms.component';
export * from './lib/third-cms.module';
